import _ from 'lodash';
import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputMaskModule } from '@ngneat/input-mask';
import { NgxCurrencyDirective } from 'ngx-currency';

@Component({
  standalone: true,
  imports:[CommonModule,ReactiveFormsModule,InputMaskModule,NgxCurrencyDirective],
  selector: 'app-move-to',
  templateUrl: './move-to.component.html',
  styleUrls: ['./move-to.component.scss']
})
export class MoveToComponent implements OnChanges, OnInit {

  @Input() index: number = 0;
  @Output() onMoveTo: EventEmitter<any> = new EventEmitter();

  public control: UntypedFormControl = null;

  constructor() {
    this.control = new UntypedFormControl(this.index);
  }

  ngOnChanges(changes: SimpleChanges) {
    const value = _.get(changes, 'index.currentValue', this.index);
    this.control.setValue(value + 1);
  }

  ngOnInit(): void {
  }

  moveTo() {
    const { index } = this;
    this.onMoveTo.emit({ index, position: this.control.value - 1 });
  }

}
